import { Button, CardHeader } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import useMCPContext from "./useMCPContext";
import { Card, CardContent } from "@altimateai/lego";
import Integration from "./Integration";
import { DatamateIntegration, TeammateSelectedIntegration } from "./mcpSlice";
import CustomIntegrationsList from "./CustomIntegrationsList";
import { OpenInNewTabIcon } from "@/assets/icons";
import useIntegrations from "../teammate/useIntegrations";
import { useIntercom } from "react-use-intercom";
import { MCPIntegrationType } from "./constants";
import { DatamatesTracking } from "@/lib/tracking/datamates";

const IntegrationSelector = () => {
  const { show } = useIntercom();
  const { teammate, removeSelectedIntegration, addSelectedIntegration } = useMCPContext();

  const { integrationsFromServer } = useIntegrations();

  const toggleIntegration = (integration: DatamateIntegration) => {
    const isCurrentlySelected = teammate?.integrations?.some(i => i.id === integration.id);
    DatamatesTracking.integrationToggled(integration.id, integration.type, !isCurrentlySelected);

    if (isCurrentlySelected) {
      removeSelectedIntegration(integration.id);
    } else {
      const selectedIntegration: TeammateSelectedIntegration = {
        id: integration.id,
        tools:
          integration.tools?.flatMap(tool =>
            (tool.enable_all ?? [tool.key]).map(k => ({ key: k }))
          ) || [],
      };
      if (integration.type === MCPIntegrationType.MCP) {
        selectedIntegration.tools = integration.tools || [];
      }
      if (integration.type === MCPIntegrationType.CODE) {
        selectedIntegration.tools = [{ key: integration.name }];
      }
      addSelectedIntegration(selectedIntegration);
    }
  };

  return (
    <>
      <Card className="al-w-full">
        <CardHeader>
          <Stack direction="row" align="center" justify="between">
            <h3 className="al-text-lg al-font-medium">Integrations</h3>
            <div className="al-text-sm al-text-gray-500">
              Looking for a integration or use case that’s not supported yet?
              <Button variant="link" onClick={() => show()}>
                Request here
              </Button>
            </div>
          </Stack>
        </CardHeader>
        <CardContent className="">
          <Stack direction="row" wrap className="al-gap-3">
            {integrationsFromServer?.map(integration => {
              const isSelected =
                teammate?.integrations?.some(i => i.id === integration.id) ?? false;

              return (
                <Integration
                  key={integration.id}
                  integration={integration}
                  isSelected={isSelected}
                  toggleIntegration={() => toggleIntegration(integration)}
                  showConfigureButton
                />
              );
            })}
          </Stack>
        </CardContent>
      </Card>
      <div className="al-mt-4">
        <Card>
          <CardHeader>
            <Stack direction="row" className="al-items-center al-justify-between">
              <h3 className="al-text-lg al-font-medium">Custom Integrations</h3>
              <Button variant="outline" size="sm" asChild>
                <a href="/datamates/custom-integrations" target="_blank" rel="noopener noreferrer">
                  <Stack direction="row" className="al-items-center al-gap-2">
                    Add custom integrations
                    <OpenInNewTabIcon className="al-w-4 al-h-4" />
                  </Stack>
                </a>
              </Button>
            </Stack>
          </CardHeader>
          <CardContent>
            <CustomIntegrationsList />
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default IntegrationSelector;
